<app-header></app-header><div class="container">
  <div class="breadcrumbs mt-4">
    <div routerLink="/">Главная</div>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 18L15 12L9 6" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <div routerLink="/">Экспертиза промышленной безопасности</div>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 18L15 12L9 6" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <div routerLink="/expprombez">Проведение экспертизы промышленной безопасности (ЭПБ)</div>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 18L15 12L9 6" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <div routerLink="/expprombez/tehus">Экспертиза промышленной безопасности технических устройств применяемых на ОПО</div>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 18L15 12L9 6" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>

  </div>
  <div class="row">
    <h1 class="w-100 mt-70">Экспертиза промышленной безопасности технических устройств применяемых на ОПО
    </h1>
    <div class="yellow-block">
      <p>С 1 сентября 2024 года <strong>изменены требования к проведению первичной экспертизы</strong> промышленной безопасности технические устройств. Срок безопасной эксплуатации снижен до 10 лет.</p>
    </div>
    <ul class="link-arrow">
      <li><svg width="12" height="12" viewBox="0 0 12 12" style="width: 10px;" fill="none"
               xmlns="http://www.w3.org/2000/svg">
        <rect x="6" y="0.34314" width="8" height="8" transform="rotate(45 6 0.34314)" fill="#494949"/>
      </svg>&nbsp; <strong>20 лет</strong> работы в области промышленной безопасности&nbsp;</li>
      <li><svg width="12" height="12" viewBox="0 0 12 12" style="width: 10px;" fill="none"
               xmlns="http://www.w3.org/2000/svg">
        <rect x="6" y="0.34314" width="8" height="8" transform="rotate(45 6 0.34314)" fill="#494949"/>
      </svg>&nbsp; <strong>более 2000</strong> успешно проведенных экспертиз более чем в 10 регионах России</li>
      <li><svg width="12" height="12" viewBox="0 0 12 12" style="width: 10px;" fill="none"
               xmlns="http://www.w3.org/2000/svg">
        <rect x="6" y="0.34314" width="8" height="8" transform="rotate(45 6 0.34314)" fill="#494949"/>
      </svg>&nbsp; <strong>231</strong> экспертиза только за 2023 год</li>
    </ul>
    <app-recall-form heading="Заказать расчет стоимости экспертизы"></app-recall-form>
    <h2>В каких случаях требуется экспертиза промышленной безопасности технических устройств:</h2>

    <ul class="marked ml-50">
      <li>перед началом применения на ОПО;</li>
      <li>по истечении срока службы или при превышении количества циклов нагрузки такого технического устройства, установленных его производителем;</li>
      <li>при отсутствии в технической документации данных о сроке службы такого технического устройства, если фактический срок его службы превышает 10 лет;</li>
      <li>после проведения работ, связанных с изменением конструкции, заменой материала несущих элементов такого технического устройства;</li>
      <li>после восстановительного ремонта после аварии или инцидента на ОПО, в результате которых было повреждено такое техническое устройство.</li>
    </ul>

    <p>По результатам проведения экспертизы выдается экспертное заключение, которое отражает обоснованные выводы о соответствии или несоответствии требованиям.&nbsp;Заключение экспертизы вносится в реестр экспертиз промышленной безопасности.</p>
    <app-atomka-calc heading="Получить консультацию по экспертизе промышленной безопасности технических устройств, цене и условиям"></app-atomka-calc>
    <h2>Почему стоит обратиться именно к нам?</h2>

    <ul class="marked ml-50">
      <li><strong>Обеспечим максимальную оперативность проведения ЭПБ</strong></li>
    </ul>

    <p>Оперативный поиск релевантного специалиста гарантирует не только оптимальный срок проведения экспертизы, но и ее абсолютную юридическую чистоту. Мы основали самую крупное сообщество экспертов России в области промышленной безопасности &laquo;Надзор-Инфо&raquo;, которое позволяет найти нужного эксперта за считанные минуты.</p>

    <ul class="marked ml-50">
      <li><strong>Имеем все необходимые лицензии и свидетельства</strong></li>
    </ul>

    <p>За 20 лет работы в сфере промышленной безопасности мы стали обладателями всех необходимых лицензий для проведения экспертиз, а также имеем аттестованную лабораторию НК с полным комплектом оборудования, необходимого для проведения ЭПБ на вашем ОПО, расположенном в Москве и в регионах.</p>

    <ul class="marked ml-50">
      <li><strong>Зафиксируем сроки и стоимость</strong></li>
    </ul>

    <p>Мы ценим свою репутацию и поэтому гарантируем прозрачность и открытость договорных отношений &mdash; все условия четко прописаны в договоре и обговариваются заранее. Стоимость зависит от объема выполняемых работ и рассчитывается индивидуально. Обеспечим гибкую систему оплаты услуг.</p>
    <div class="mt-5 row">
      <div class="col">
        <img src="assets/img_28.png" height="880" alt="" style="width: 100%">
        <p class="text-center">Лицензия ООО "Протос Экспертиза"</p>
      </div>
      <div class="col">
        <img src="assets/img_29.png" height="880" style="width: 100%;" alt="">
        <p class="text-center">Свидетельство об аттестации ЛНК</p>

      </div>
    </div>
    <h2>Процедура проведения экспертизы промышленной безопасности технических устройств:</h2>

    <ol class="marked">
      <li>Анализ технической документации относящейся к объекту экспертизы на предмет полноты и достоверности технической документации, которая относится к конкретному техническому устройству;</li>
      <li>Разработка и оформление индивидуальной программы диагностирования с учетом анализа условий эксплуатации, предыдущих обследований, особенностей конструкции и т. д.</li>
      <li>Проведение технического диагностирования, включающее в себя функциональную диагностику, контроль методами неразрушающего и разрушающего контроля, поверочные расчеты на прочность, испытания на прочность, плотность, герметичность для определения текущего состояния технического устройства. &nbsp;</li>
      <li>Анализ результатов технического диагностирования.&nbsp;</li>
      <li>Составление акта по результатам технического диагностирования за подписью руководителя экспертной организации.</li>
      <li>Оформление заключения экспертизы промышленной безопасности с выводами о возможности, условиях и сроках дальнейшей безопасной эксплуатации объекта экспертизы.</li>
      <li>Регистрация заключения экспертизы промышленной безопасности в органах Ростехнадзора.</li>
    </ol>

    <p>На текущий момент число наших клиентов превышает<strong> несколько тысяч</strong> российских и зарубежных организаций &mdash; это компании производители оборудования, используемого на опасных производственных объектах; компании, которые эксплуатируют опасные производственные объекты, и компании, которые проводят экспертизу промышленной безопасности.<br />
      &nbsp;</p>
    <app-recall-form heading="Заказать расчет стоимости экспертизы"></app-recall-form>
    <app-reviews-block class="w-100"></app-reviews-block>
  </div>
</div><app-footer></app-footer>
